import { CustomEquipmentDraft } from "./types";

export const initialCustomEquipmentDraft: CustomEquipmentDraft = {
  name: "",
  description: "",
  priceEur: null,
};
